// extracted by mini-css-extract-plugin
export default {"cameraIcon":"v0dHS___EditableAsset-module__cameraIcon"};